module.exports = __webpack_public_path__ + "img/1F1EB-1F1F2.7c14f75c.svg";